import { W as WuiButton$1, d as defineCustomElement$1 } from './p-C-AXl3sC.js';

const WuiButton = WuiButton$1;
const defineCustomElement = defineCustomElement$1;

export { WuiButton, defineCustomElement };
